export const CLIENT_ERROR_CATEGORY = 'client';
export const DEPENDENCY_ERROR_CATEGORY = 'dependency';
export const INTERNAL_ERROR_CATEGORY = 'internal';

export class DependencyError extends Error {
  constructor(message) {
    super(message);
    this.category = DEPENDENCY_ERROR_CATEGORY;
  }
}

export class ClientError extends Error {
  constructor(message) {
    super(message);
    this.category = CLIENT_ERROR_CATEGORY;
  }
}
